import _ from 'lodash';

const proxyToInt = import.meta.env.VITE_PROXY_TO_INT === 'true';

let apiBase = proxyToInt ? 'https://int.api.muzado.com' : '';
let userImageServerRoot = 'https://int.assets.muzado.com';
let dynamicAssetServerRoot = proxyToInt ? 'https://int.api.muzado.com' : '';
let cookieDomain = 'localhost';
let loginPageURL = '/login';
let logoutPageURI = '/main/';

switch (import.meta.env.MODE) {
	case 'int':
		apiBase = 'https://int.api.muzado.com';
		userImageServerRoot = 'https://int.assets.muzado.com';
		dynamicAssetServerRoot = 'https://int.api.muzado.com';
		loginPageURL = 'https://int.muzado.com/login';
		logoutPageURI = 'https://int.muzado.com/login';
		cookieDomain = '.muzado.com';
		break;
	case 'production':
		apiBase = 'https://api.muzado.com';
		userImageServerRoot = 'https://assets.muzado.com';
		dynamicAssetServerRoot = 'https://api.muzado.com';
		loginPageURL = 'https://muzado.com/login';
		logoutPageURI = 'https://muzado.com/login';
		cookieDomain = '.muzado.com';
		break;
}

const config = {
	gapiKey: 'AIzaSyA0Drpbq3rmbl4SbuJYKtjWQZThU92ZDso',
	apiBase, userImageServerRoot, dynamicAssetServerRoot,
	cookieDomain, loginPageURL, logoutPageURI,

	rules: {
		MAX_ARTIST_PHOTOS: 15,
		MAX_SONG_PREVIEW_LENGTH: 45,
		MAX_SONG_LISTEN_EVENT_DURATION_SECONDS: 10
	},

	cognito: {
		region: 'us-east-1',
		userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
		userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID
	},

	routes: {
		login: `${apiBase}/api/auth`, // deprecated
		logout: logoutPageURI, // deprecated

		initial: `${apiBase}/api/initial`,
		profile: `${apiBase}/api/users/session/profile`,

		confirmUser: `${apiBase}/api/auth/confirm-user`,

		users: `${apiBase}/api/users`,
		usersPaged: `${apiBase}/api/paged/users?page=:page&limit=:limit`,
		user: `${apiBase}/api/users/:id`,
		createUser: `${apiBase}/api/users/create`,
		removeProfileImage: `${apiBase}/api/users/remove/profile-image/:id`,
		updatePassword: `${apiBase}/api/users/password/:id`,
		checkEmail: `${apiBase}/api/users/check-email/:email`,

		createArtist: `${apiBase}/api/artists/create`,
		createAlbum: `${apiBase}/api/albums/create`,
		artists: `${apiBase}/api/artists`,
		artist: `${apiBase}/api/artists/:id`,
		// Member-facing BFF list — PII-suppressed. Use for browse/search/etc.
		// The generic /api/artists is now gated to admin + self.
		bffMembersArtists: `${apiBase}/bff/members/artists`,
		artistDailyStats: `${apiBase}/api/artists/daily-stats/:id`,
		deleteArtist: `${apiBase}/api/artists/remove/:id`,

		playlists: `${apiBase}/api/playlists`,
		playlist: `${apiBase}/api/playlists/:id`,
		playlistCreate: `${apiBase}/api/playlists/create`,
		playlistRemove: `${apiBase}/api/playlists/remove/:id`,
		playlistArtworkUpload: `${apiBase}/api/playlists/upload/artwork/:id`,
		playlistMemberHomeLists: `${apiBase}/api/playlists/agg/member-home-lists`,

		documents: `${apiBase}/api/documents`,
		documentCreate: `${apiBase}/api/documents`,
		document: `${apiBase}/api/documents/:id`,

		labels: `${apiBase}/api/labels`,
		labelCreate: `${apiBase}/api/labels`,
		label: `${apiBase}/api/labels/:id`,

		albums: `${apiBase}/api/albums`,
		album: `${apiBase}/api/albums/:id`,
		songs: `${apiBase}/api/songs`,
		song: `${apiBase}/api/songs/:id`,

		genres: `${apiBase}/api/genres`,
		genreCreate: `${apiBase}/api/genres/create`,
		genreRemove: `${apiBase}/api/genres/remove/:id`,
		genreArtworkUpload: `${apiBase}/api/genres/upload/artwork/:id`,

		subscription: `${apiBase}/api/subscriptions`,
		attachPaymentMethod: `${apiBase}/api/subscriptions/attach-payment-method/:id`,
		mzdEvent: `${apiBase}/api/mzd-events`,

		deleteSong: `${apiBase}/api/songs/remove/:id`,
		delete: `${apiBase}/api/:collection/:id`,
		albumssyArtist: `${apiBase}/api/albums/artist/:artistID`,
		songsByArtist: `${apiBase}/api/songs/artist/:artistID`,
		songsStatus: `${apiBase}/api/songs/status/:artistID`,
		profileImageUpload: `${apiBase}/api/profile-image/upload/:id`,
		bannerImageUpload: `${apiBase}/api/banner-image/upload/:id`,
		mobileBannerImageUpload: `${apiBase}/api/mobile-banner-image/upload/:id`,
		artistPhotoUpload: `${apiBase}/api/artist-photo/upload/:id`,
		albumArtworkUpload: `${apiBase}/api/albums/upload/artwork/:id`,
		searchGenres: `${apiBase}/api/genres/search/:search`,
		songUpload: `${apiBase}/api/songs/upload/:id`,
		songUploadPresigned: `${apiBase}/api/songs/upload-presigned/:id`,
		songUploadComplete: `${apiBase}/api/songs/upload-complete/:id`,
		songFullPreviewPosition: `${apiBase}/api/songs/full-preview-position/:id`,
		songFullPreviewRemove: `${apiBase}/api/songs/full-preview-remove/:id`,
		getCreditCardList: `${apiBase}/api/subscriptions/card-list/:memberID`,
		createAccountLink: `${apiBase}/api/artists/create-account-link/:id`,
		createConnectAccount: `${apiBase}/api/artists/create-connect-account`,
		retrieveConnectAccount: `${apiBase}/api/artists/retrieve-connect-account/:id`,

		setArtistMoods: `${apiBase}/api/artists/moods/:id`,
		addArtistMood: `${apiBase}/api/artists/moods/:id`,
		deleteArtistMoodByName: `${apiBase}/api/artists/moods/:id/:name`,

		setSongMoods: `${apiBase}/api/songs/moods/:id`,
		addSongMood: `${apiBase}/api/songs/moods/:id`,
		deleteSongMoodByName: `${apiBase}/api/songs/moods/:id/:name`,
		
		search: `${apiBase}/api/search`,
	},

	paths: {
		stripeRegister: 'https://dashboard.stripe.com/register',
		songBasePath: `${dynamicAssetServerRoot}/assets/public/s3/song`,
		imgBasePath: '/assets/public/s3/img',
		albumImgBasePath: userImageServerRoot,
		profileImgBasePath: userImageServerRoot,
		bannerImgBasePath: userImageServerRoot,
		defaultProfileImgBasePath: `${dynamicAssetServerRoot}/profile-images/default-artist-profile-img.jpg`,
		defaultBannerImgBasePath: `${dynamicAssetServerRoot}/banner-images/default-artist-banner-img.jpg`,

		admin: {
			submissionsHomePath: '#/submissions',
			submissionsArtistPath: '#/submissions/artist/:id'
		}
	},

	fb: {
		appID: '1472223746211834'
	},

	services: {
		api: 'http://hfm-api:3000',
		auth: 'http://hfm-auth:3000/api/auth',
		authCheck: 'http://hfm-auth:3000/api/auth/check',
		authTerm: 'http://hfm-auth:3000/api/auth/terminate',
		users: 'http://hfm-api:3000/api/users',
		artists: 'http://hfm-api:3000/api/artists',
		profile: 'http://hfm-api:3000/api/user/profile'
	}
};

const getRoute = (key, id = null) => {
	const route = config.routes[key];

	if (_.isNull(id) || _.isEmpty(route)) {

		return route;
	}

	return route.replace(/\:id/, id);
}

export default {
	...config,
	getRoute
};
